/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_PriorityInputs */

const en_sort_priority = /** @type {(inputs: Sort_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const de_sort_priority = /** @type {(inputs: Sort_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorität`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Sort_PriorityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_priority = /** @type {((inputs?: Sort_PriorityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_PriorityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_priority(inputs)
	return en_sort_priority(inputs)
});